let clearSessionFn = () => {};

export const setAuthHelper = (clearSession) => {
  clearSessionFn = clearSession;
};

export const clearSession = () => {
  clearSessionFn();
};
